"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var Link_1 = __importDefault(require("@mui/material/Link"));
var mountIsland_1 = require("../mountIsland");
var Lang_js_1 = require("../Lang.js");
var apiResponse_1 = require("../apiResponse");
var FormHeader_1 = __importDefault(require("./FormHeader"));
var ReadOnlySection_1 = __importDefault(require("./ReadOnlySection"));
var SubscriptionStatus_1 = __importDefault(require("./SubscriptionStatus"));
var FeePaymentStatus_1 = __importDefault(require("./FeePaymentStatus"));
var RenewInputFields_1 = __importDefault(require("./RenewInputFields"));
var CustomDialog_1 = __importDefault(require("../Generic/CustomDialog"));
var renewalDueDateLogic_js_1 = require("./renewalDueDateLogic.js");
// ─── Component ───────────────────────────────────────────────────────────────
function EditRenewal() {
    var _a, _b;
    var _c = (0, react_1.useState)({
        id: (_b = (_a = document.getElementById('edit-renewal')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-id')) !== null && _b !== void 0 ? _b : '',
        memberid: '',
        first: '',
        last: '',
        salutation: '',
        adr1: '',
        adr2: '',
        adr3: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        renewal_date: '',
        ordination_date: '',
        reinstatement_date: '',
        home_phone: '',
        cell_phone: '',
        email: '',
        attend_monthly_meetings: '',
        attend_monthly_meetings_explanation: '',
        self_supporting: '',
        self_supporting_explanation: '',
        tithing: '',
        tithing_explanation: '',
        marijuana_cbd: '',
        marijuana_cbd_explanation: '',
        marijuana_cbd_intention: '',
        felony: '',
        felony_explanation: '',
        subscription_status: '',
        renewal_needed_by: '',
        fee_payment_status: '',
        fee_payment_method: '',
        fee_payment_method_other_description: '',
        fee_payment_amount: '',
        fee_payment_date: '',
        accomplishments: '',
        direction: '',
        signature: '',
    }), renewal = _c[0], setRenewal = _c[1];
    var formRef = (0, react_1.useRef)(null);
    var _d = (0, react_1.useState)(false), showSpinner = _d[0], setShowSpinner = _d[1];
    var _e = (0, react_1.useState)(false), isValid = _e[0], setIsValid = _e[1];
    var _f = (0, react_1.useState)(false), showOtherDescription = _f[0], setShowOtherDescription = _f[1];
    var _g = (0, react_1.useState)(false), isStatusBarFloating = _g[0], setIsStatusBarFloating = _g[1];
    var _h = (0, react_1.useState)(false), openDialog = _h[0], setOpenDialog = _h[1];
    var _j = (0, react_1.useState)({
        title: '',
        content: '',
        onConfirm: function () { },
        confirmText: 'OK',
        cancelText: 'Cancel',
    }), dialogConfig = _j[0], setDialogConfig = _j[1];
    var showError = function (content) {
        setDialogConfig({
            title: (0, Lang_js_1.__)('Error'),
            content: content,
            onConfirm: function () { return setOpenDialog(false); },
            confirmText: 'OK',
            cancelText: 'Cancel',
        });
        setOpenDialog(true);
    };
    (0, react_1.useEffect)(function () {
        var idElement = document.getElementById('edit-renewal');
        if (idElement) {
            var idValue_1 = idElement.getAttribute('data-id');
            if (idValue_1) {
                setRenewal(function (prevRenewal) { return (__assign(__assign({}, prevRenewal), { id: idValue_1 })); });
            }
        }
    }, []);
    var validateForm = function (_updatedData) {
        setIsValid(true);
    };
    (0, react_1.useEffect)(function () {
        validateForm(renewal);
    }, [renewal]);
    var id = window.location.pathname.split('/').pop();
    (0, react_1.useEffect)(function () {
        axios_1.default
            .get("/api/ministry/renewal?id=".concat(id))
            .then(function (response) {
            if (!(0, apiResponse_1.isJsonSuccess)(response) || !response.data.renewal) {
                console.error('Unexpected response loading renewal', response.status, response.data);
                showError((0, Lang_js_1.__)('Your renewal could not be loaded. Please reload the page, and sign in again if you are prompted to.'));
                return;
            }
            var sanitizedRenewal = Object.keys(response.data.renewal).reduce(function (acc, key) {
                var _a;
                if (['attend_monthly_meetings', 'self_supporting', 'tithing', 'marijuana_cbd', 'felony'].includes(key)) {
                    acc[key] =
                        response.data.renewal[key] !== null
                            ? response.data.renewal[key].toString()
                            : '';
                }
                else {
                    acc[key] = (_a = response.data.renewal[key]) !== null && _a !== void 0 ? _a : '';
                }
                return acc;
            }, {});
            setRenewal(sanitizedRenewal);
        })
            .catch(function (error) {
            console.error('There was an error!', error);
        });
    }, [id]);
    (0, react_1.useEffect)(function () {
        var handleScroll = function () {
            var scrollY = window.scrollY;
            var threshold = 100;
            if (scrollY > threshold) {
                setIsStatusBarFloating(true);
            }
            else {
                setIsStatusBarFloating(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    var handleChange = function (e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        var updatedRenewal = __assign(__assign({}, renewal), (_a = {}, _a[name] = value, _a));
        validateForm(updatedRenewal);
        setRenewal(updatedRenewal);
        setShowSpinner(true);
        axios_1.default
            .put('/api/ministry/renewal', {
            id: updatedRenewal['id'],
            renewal: updatedRenewal,
            submit: false,
        })
            .then(function (response) {
            setShowSpinner(false);
            if (!(0, apiResponse_1.isJsonSuccess)(response)) {
                console.error('Autosave rejected', response.status, response.data);
                showError((0, Lang_js_1.__)('Your changes could not be saved. Please check your connection and try again before leaving this page.'));
            }
        })
            .catch(function (error) {
            console.error('There was an error!', error);
            setShowSpinner(false);
            showError((0, Lang_js_1.__)('Your changes could not be saved. Please check your connection and try again before leaving this page.'));
        });
    };
    var handleSubmit = function (e) {
        e.preventDefault();
        var isFormHtml5Valid = formRef.current && formRef.current.checkValidity();
        if (!isFormHtml5Valid) {
            setDialogConfig({
                title: (0, Lang_js_1.__)('Input Error'),
                content: (0, Lang_js_1.__)('Please check your input.'),
                onConfirm: function () { return setOpenDialog(false); },
                confirmText: 'OK',
                cancelText: 'Cancel',
            });
            setOpenDialog(true);
            return;
        }
        var requiredRadios = [
            'attend_monthly_meetings',
            'self_supporting',
            'tithing',
            'marijuana_cbd',
            'felony',
        ];
        var missingSelection = requiredRadios.find(function (key) { return renewal[key] === '' || renewal[key] == null; });
        if (missingSelection) {
            setDialogConfig({
                title: (0, Lang_js_1.__)('Missing Selection'),
                content: (0, Lang_js_1.__)('All radio buttons must be answered.'),
                onConfirm: function () { return setOpenDialog(false); },
                confirmText: 'OK',
                cancelText: 'Cancel',
            });
            setOpenDialog(true);
            return;
        }
        setDialogConfig({
            title: (0, Lang_js_1.__)('Confirmation'),
            content: (0, Lang_js_1.__)('Are you sure you want to submit your renewal? You cannot update/edit after this.'),
            confirmText: (0, Lang_js_1.__)('Submit'),
            onConfirm: function () {
                setOpenDialog(false);
                submitForm();
            },
            cancelText: (0, Lang_js_1.__)('Cancel'),
        });
        setOpenDialog(true);
    };
    var submitForm = function () {
        setShowSpinner(true);
        var updatedRenewal = __assign(__assign({}, renewal), { status: 'submitted' });
        axios_1.default
            .put('/api/ministry/renewal', {
            id: updatedRenewal['id'],
            renewal: updatedRenewal,
            submit: true,
        })
            .then(function (response) {
            if (!(0, apiResponse_1.isJsonSuccess)(response) || !('result' in response.data)) {
                setShowSpinner(false);
                console.error('Unexpected response submitting renewal', response.status, response.data);
                showError((0, Lang_js_1.__)('Your renewal could not be submitted. Your answers are still here — please try again, and sign in again if you are prompted to.'));
                return;
            }
            var result = response.data.result;
            if (result && result.status === 'submitted') {
                if (!response.data.email_sent) {
                    console.error('Failed to send email');
                }
                window.location.href = '/app/ministry/renewals/';
                return;
            }
            // The server rejected the submission — surface which answers are still outstanding
            // rather than leaving the minister with a stopped spinner and no explanation.
            setShowSpinner(false);
            var missing = Array.isArray(response.data.errors) ? response.data.errors : [];
            missing.forEach(function (error) {
                console.error('Empty field: ' + error);
            });
            showError(missing.length
                ? (0, Lang_js_1.__)('Your renewal is not complete yet. Please answer the following before submitting:') + ' ' + missing.join(', ')
                : (0, Lang_js_1.__)('Your renewal could not be submitted. Your answers are still here — please try again, and sign in again if you are prompted to.'));
        })
            .catch(function (error) {
            setShowSpinner(false);
            console.error('There was an error!', error);
            showError((0, Lang_js_1.__)('Your renewal could not be submitted. Your answers are still here — please try again, and sign in again if you are prompted to.'));
        });
    };
    var dateParts = renewal.renewal_date.split('-');
    var renewal_year = dateParts[0];
    var renewalStatus = (0, renewalDueDateLogic_js_1.getRenewalStatus)(renewal.renewal_date, renewal.status, renewal.submitted_date);
    var translatedUrl = (0, Lang_js_1.__)('https://www.youtube.com/watch?v=1ITFOg1Zzrc');
    var translatedText = (0, Lang_js_1.__)('If you need assistance with your renewal or want additional context on the questions below, click here to view a support video.');
    return (react_1.default.createElement("div", { className: "form-container" },
        react_1.default.createElement("div", { className: "help-link" },
            react_1.default.createElement(Link_1.default, { href: translatedUrl, target: "_blank", rel: "noopener noreferrer", underline: "hover" }, translatedText)),
        showSpinner && react_1.default.createElement("div", { className: "spinner" }),
        react_1.default.createElement("div", { className: "status-bar ".concat(renewalStatus.colorClass, " ").concat(isStatusBarFloating ? 'floating-status-bar' : '') }, renewalStatus.text),
        react_1.default.createElement(FormHeader_1.default, { renewal_year: renewal_year }),
        react_1.default.createElement("form", { ref: formRef, onSubmit: handleSubmit, className: "renewal-form" },
            react_1.default.createElement(ReadOnlySection_1.default, { renewal: renewal }),
            react_1.default.createElement("hr", null),
            react_1.default.createElement("div", null,
                react_1.default.createElement(SubscriptionStatus_1.default, { renewal: renewal }),
                react_1.default.createElement("hr", null),
                react_1.default.createElement(FeePaymentStatus_1.default, { renewal: renewal, showOtherDescription: showOtherDescription, setShowOtherDescription: setShowOtherDescription, handleChange: handleChange })),
            react_1.default.createElement("hr", null),
            react_1.default.createElement(RenewInputFields_1.default, { renewal: renewal, handleChange: handleChange }),
            renewal.status !== 'submitted' && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("input", { type: "hidden", name: "status", value: "submitted" }),
                react_1.default.createElement(Button_1.default, { variant: "contained", type: "submit", disabled: !isValid }, (0, Lang_js_1.__)('Submit'))))),
        react_1.default.createElement(CustomDialog_1.default, { open: openDialog, onClose: function () { return setOpenDialog(false); }, onConfirm: dialogConfig.onConfirm, title: dialogConfig.title, content: dialogConfig.content, confirmText: dialogConfig.confirmText, cancelText: dialogConfig.cancelText }),
        renewal.status !== 'submitted' && (react_1.default.createElement("div", { id: "save-for-later" },
            react_1.default.createElement(Link_1.default, { href: "/app/ministry/renewals/", className: "button-link", underline: "hover" }, (0, Lang_js_1.__)('Save For Later'))))));
}
// ─── Mount ───────────────────────────────────────────────────────────────────
var editRenewalsContainer = document.getElementById('edit-renewal');
if (editRenewalsContainer) {
    (0, mountIsland_1.mountIsland)(editRenewalsContainer, react_1.default.createElement(EditRenewal, null));
}
